// @flow

import styles from "../BankInquiryApplication.scss";
import { generateDescriptionList } from "../generateDescriptionList";

type GeneralDataProps = {
  data: any
};

const LoanGuaranteeDetails = ({ data }: GeneralDataProps) => {
  // Create configuration object for the description list
  const descriptionListConfig = {
    sections: [
      // Dynamic loan guarantee sections
      ...(data?.details?.inquiry?.details?.map(loan => [
        {
          title: "Zu verbürgendes Darlehen",
          items: [
            {
              label: "Art des Kredits",
              data: loan.type
            },
            {
              label: "Kreditbetrag",
              data: loan.amount
            },
            {
              label: "Laufzeit (monate)",
              data: loan.durationInMonths
            },
            {
              label: "Freijahre (monate)",
              data: loan.nonrepaymentMonths
            },
            {
              label: "Tilgungstyp",
              data: loan.amortisationType
            },
            {
              label: "Jährliche Rückzahlung",
              data: loan.payment
            },
            {
              label: "Zinssatz",
              data: loan.indicationInterest
            },
            {
              label: "Verbürgungsgrad",
              data: loan.guaranteeRatio
            },
            {
              label: "Finanzmittelnehmer oder -geber",
              data: loan.borrowerName
            }
          ]
        }
      ]) || [])
    ]
  };

  return generateDescriptionList(descriptionListConfig, styles.descriptionList);
};

export default LoanGuaranteeDetails;
